import { useTranslation } from 'react-i18next';
import { Empty } from 'shared/ui';
import NoDashboardIcon from '../assets/no-dashboard-icon.svg?react';
import cls from './dashboard-no-dashboard.module.scss';

export const DashboardNoDashboard = () => {
	const { t } = useTranslation();

	return (
		<div className={cls.dashboardNoDashboard}>
			<Empty
				icon={<NoDashboardIcon />}
				title={t('dashboard-page.no-dashboard.title')}
				message={t('dashboard-page.no-dashboard.message')}
			/>
		</div>
	);
};
